import './index.scss'
import { ToastContainer, Toast, Image } from 'react-bootstrap';
import closeBtn from '@/static/images/closeBtn.png'
import { useEffect } from 'react';
function DzPop({
    children,
    mask,
    popShow = false,
    toggleShow,
    content,
    closeClick
}) {
    useEffect(() => {
        console.log('DzPop mounted',mask);
    }, [])
    return (
        <>
            {mask?<div className='dz-pop-bg' style={{ display: popShow ? 'block' : 'none',width:'100%',height:'100%',position:'fixed',left:0,top:0 }} onClick={e => closeClick()}></div>:''}
            <ToastContainer position='middle-center' className='dz-pop'>
                <Toast bg="light" show={popShow}>
                    <Toast.Body>
                        <Image src={closeBtn} width={20} onClick={e => closeClick()} className="close-btn pointer" />
                        <div className='toast-content'>
                            {children}
                        </div>
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    )
}
export default DzPop;